import { useCustomCreateProposalWorksheetItemMutation } from "generated/graphql";
import getLocalString from "constants/Localization";
import useBitumioMutation from "hooks/useBitumioMutation";

export default function useCreateProposalWorksheetItem() {
  const [mutation, { loading, data, error }] = useCustomCreateProposalWorksheetItemMutation({
    refetchQueries: ["getProposal", "customGetProposal"],
    awaitRefetchQueries: true,
  });
  const [createProposalWorksheetItem, context] = useBitumioMutation(
    {
      mutation,
      loading,
      data,
      error,
      key: "createProposalWorksheetItem",
    },
    {
      successMessage: getLocalString("worksheet.create-item-success"),
      failureMessage: getLocalString("worksheet.create-item-failure"),
      showValidationErrors: true,
    }
  );

  return [createProposalWorksheetItem, context] as const;
}
